import { Outlet } from 'react-router-dom'
import Sidebar from '../Sidebar/'
import './index.scss'

/**
 * Page shell with the sidebar navigation and the routed page content.
 */
const Layout = () => {
  return (
    <div className="App">
      <Sidebar />
        <Outlet />
    </div>
  )
}

export default Layout